import { render } from "./ReplenishmentModal.vue?vue&type=template&id=4607654a"
import script from "./ReplenishmentModal.vue?vue&type=script&lang=js"
export * from "./ReplenishmentModal.vue?vue&type=script&lang=js"

import exportComponent from "/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__